import { useTranslation } from 'react-i18next'

const ZH_NAMES: Record<string, string> = {
  // Group A
  USA: '美国', PAN: '巴拿马', HON: '洪都拉斯', JAM: '牙买加',
  // Group B
  MEX: '墨西哥', ECU: '厄瓜多尔', CUB: '古巴', CAN: '加拿大',
  // Group C
  ARG: '阿根廷', CHI: '智利', PER: '秘鲁', BOL: '玻利维亚',
  // Group D
  BRA: '巴西', VEN: '委内瑞拉', URU: '乌拉圭', PAR: '巴拉圭',
  // Group E
  ENG: '英格兰', NED: '荷兰', SCO: '苏格兰', TRI: '特立尼达和多巴哥',
  // Group F
  FRA: '法国', BEL: '比利时', WAL: '威尔士', ALG: '阿尔及利亚',
  // Group G
  ESP: '西班牙', POR: '葡萄牙', MAR: '摩洛哥', KSA: '沙特阿拉伯',
  // Group H
  GER: '德国', SUI: '瑞士', SRB: '塞尔维亚', CMR: '喀麦隆',
  // Group I
  ITA: '意大利', CRO: '克罗地亚', ALB: '阿尔巴尼亚', NGA: '尼日利亚',
  // Group J
  NOR: '挪威', TUR: '土耳其', CZE: '捷克', RSA: '南非',
  // Group K
  JPN: '日本', IRI: '伊朗', AUS: '澳大利亚', IRQ: '伊拉克',
  // Group L
  KOR: '韩国', SAU: '沙特阿拉伯', QAT: '卡塔尔', UZB: '乌兹别克斯坦',
  // Additional common codes
  POL: '波兰', DEN: '丹麦', SWE: '瑞典', FIN: '芬兰',
  SVK: '斯洛伐克', SVN: '斯洛文尼亚', HUN: '匈牙利', ROM: '罗马尼亚',
  BIH: '波黑', KOS: '科索沃', MNE: '黑山', MKD: '北马其顿',
  GRE: '希腊', BUL: '保加利亚', ISL: '冰岛', NIR: '北爱尔兰',
  IRL: '爱尔兰', AUT: '奥地利', RUS: '俄罗斯', UKR: '乌克兰',
  MEX2: '墨西哥', COL: '哥伦比亚', CRC: '哥斯达黎加', GUA: '危地马拉',
  SLV: '萨尔瓦多', NCA: '尼加拉瓜', BLZ: '伯利兹',
  HAI: '海地', DOM: '多米尼加', GRN: '格林纳达', SKN: '圣基茨和尼维斯',
  GHA: '加纳', CIV: '科特迪瓦', SEN: '塞内加尔', EGY: '埃及',
  TUN: '突尼斯', ETH: '埃塞俄比亚', KEN: '肯尼亚', TAN: '坦桑尼亚',
  ANG: '安哥拉', CON: '刚果', MOZ: '莫桑比克', ZIM: '津巴布韦',
  ZAM: '赞比亚', NAM: '纳米比亚', BOT: '博茨瓦纳', UGA: '乌干达',
  GAB: '加蓬', BEN: '贝宁', MLI: '马里', GNB: '几内亚比绍',
  BFA: '布基纳法索', TOG: '多哥', CPV: '佛得角', GAM: '冈比亚',
  LBR: '利比里亚', SLE: '塞拉利昂', GUI: '几内亚', MTN: '毛里塔尼亚',
  CHN: '中国', IND: '印度', VIE: '越南', THA: '泰国',
  PHI: '菲律宾', IDN: '印度尼西亚', MYS: '马来西亚', SIN: '新加坡',
  OMA: '阿曼', UAE: '阿联酋', JOR: '约旦', SYR: '叙利亚',
  LIB: '黎巴嫩', PAL: '巴勒斯坦', BHR: '巴林', KUW: '科威特',
  MEX3: '墨西哥',
}

export function useLocalizedTeamName() {
  const { i18n } = useTranslation()
  const isZh = i18n.language.startsWith('zh')

  return function getTeamName(id: string | null | undefined, englishName: string | null | undefined): string {
    const name = englishName ?? id ?? 'TBD'
    if (!isZh || !id) return name
    return ZH_NAMES[id] ?? name
  }
}
